import { useQuery } from '@tanstack/react-query';
import { useGraphQLClient } from 'hooks';

const useGetUpcomingPromoted = () => {
  const { graphql, graphQLClient, hasToken } = useGraphQLClient();

  const getUpcomingPromotedSql = graphql(`
    query GetUpcomingPromoted {
      getUpcomingPromoted {
        weeklyPrizePool
        promotedTracks {
          from
          to
          track {
            frontendName
            trackName
          }
        }
      }
    }
  `);

  const getUpcomingPromoted = useQuery({
    enabled: Boolean(hasToken),
    queryKey: ['getUpcomingPromoted'],
    staleTime: Infinity,
    queryFn: async () => {
      return graphQLClient.request(getUpcomingPromotedSql);
    },
  });
  return getUpcomingPromoted;
};

export default useGetUpcomingPromoted;
